import React, { Component } from "react";
import ZPartner01GrabHeader from "./ZPartner01GrabHeader";
import ZPartner01GrabFooter from "./ZPartner01GrabFooter";
import { getClientId } from "./utils/analyticsclientIdUtils";

export class ZPartner01Grab extends Component {
    static displayName = ZPartner01Grab.name;

    constructor(props) {
        super(props);
        this.state = {
            grabUserId: "",
            merchantId: "",
            termsChecked: false,
        };

        this.__isUnmounted = false;

        this.handleTermsChange = this.handleTermsChange.bind(this);
        this.handleSubmitYes = this.handleSubmitYes.bind(this);
        this.handleSubmitNo = this.handleSubmitNo.bind(this);
    }

    componentWillUnmount() {
        this.__isUnmounted = true;
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner01_Index";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        this.initFromGrabWebView();
    }

    initFromGrabWebView() {
        try {
            // Run only once per page load
            if (window.__grabInitOnce) return;
            window.__grabInitOnce = true;

            // grabWebView function must inject
            //if (
            //    window.grabWebView &&
            //    typeof window.grabWebView.passInfoToWebView === "function"
            //) {
            //    const response = window.grabWebView.passInfoToWebView();

            //    if (response) {
            //        const data = JSON.parse(response);

            //        this.setState({
            //            grabUserId: String(data.grabUserId ?? "").trim(),
            //            merchantId: String(data.merchantId ?? "").trim(),
            //        });
            //    } else {
            //        window.location.replace("/X01PartnerConnect/Error?S=1");
            //    }
            //} else {
            //    window.location.replace("/X01PartnerConnect/Error?S=2");
            //}

            if (
                window.grabWebView &&
                typeof window.grabWebView.passInfoToWebView === "function"
            ) {
                const response = window.grabWebView.passInfoToWebView();
                if (!response) {
                    window.location.replace("/X01PartnerConnect/Error?S=2");
                    return;
                }

                const data = JSON.parse(response);
                return this.applyGrabData({
                    grabUserId: String(data.grabUserId ?? "").trim(),
                    merchantId: String(data.merchantId ?? "").trim(),
                });
            }

            window.location.replace("/X01PartnerConnect/Error?S=2");
        } catch (e) {
            if (e instanceof ReferenceError) {
                window.location.replace("/X01PartnerConnect/Error?S=3");
            } else {
                window.location.replace("/X01PartnerConnect/Error?S=4");
            }
        }
    }

    applyGrabData(data) {
        const grabUserId = String(data?.grabUserId ?? "").trim();
        const merchantId = String(data?.merchantId ?? "").trim();

        if (!grabUserId && !merchantId) {
            window.location.replace("/X01PartnerConnect/Error?S=1");
            return;
        }

        if (this.__isUnmounted) return;

        this.setState({
            grabUserId,
            merchantId,
        });
    }

    handleTermsChange(event) {
        this.setState({ termsChecked: event.target.checked });
    }

    handleSubmitYes(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X01PartnerConnect/MemberSignIn",
            state: {
                grabUserId: this.state.grabUserId,
                merchantId: this.state.merchantId
            }
        });
    }

    handleSubmitNo(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X01PartnerConnect/MemberNew",
            state: {
                grabUserId: this.state.grabUserId,
                merchantId: this.state.merchantId
            }
        });
    }

    render() {
        const { grabUserId, merchantId, termsChecked } = this.state;

        return (
            <>
                <ZPartner01GrabHeader />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">ข้อกำหนดและเงื่อนไขเกี่ยวกับการผูกบัญชีสมาชิก Grab และ Starbucks® Rewards</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3 ">
                                    <div className="py-5 p-4 box-sign-in text-break">
                                        <p>1 บัญชีสมาชิก Grab สามารถทำการผูกกับ 1 บัญชีสมาชิก Starbucks® Rewards ต่อครั้งเท่านั้น</p>
                                        <p>เมื่อทำการผูกบัญชีสมาชิกไว้ด้วยกันแล้ว จะสามารถสะสมดาวในโปรแกรม Starbucks® Rewards เมื่อมีการซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน Grab และเป็นร้านที่สร้างขึ้นโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด โดยทุก ๆ 50 บาทของการใช้จ่าย สมาชิก Starbucks® Rewards จะได้รับดาว Starbucks® Rewards 1 ดวง</p>
                                        <p>ยอดใช้จ่ายที่นำมาคำนวณดาว จะคำนวณจากยอดใช้จ่ายสุทธิในใบเสร็จที่ออกโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด เท่านั้นไม่รวมค่าบริการจัดส่ง</p>
                                        <p>การซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน Grab และเป็นร้านที่สร้างขึ้นโดย บริษัท คอฟฟี่ คอนเซ็ปต์ รีเทล จำกัด จะไม่เข้าร่วมกิจกรรมส่งเสริมการขายใด ๆ ที่เกิดขึ้น ณ ร้านสตาร์บัคส์ เว้นแต่สตาร์บัคส์จะกำหนดเป็นอย่างอื่นไว้เป็นการเฉพาะ และไม่ถือเป็นการใช้จ่าย ณ ร้านสตาร์บัคส์ เพื่อรับดาว หรือดาวโบนัส สำหรับการซื้อ ณ ร้านสตาร์บัคส์</p>
                                        <p>หากคุณมีบัญชีสมาชิก Starbucks® Rewards แล้ว กรุณาคลิกปุ่มด้านล่างซ้าย เพื่อทำการกรอกอีเมล และรหัสผ่านของบัญชีสมาชิก Starbucks® Rewards เพื่อผูกบัญชีสมาชิก Grab กับบัญชีสมาชิก Starbucks® Rewards หลังจากนั้นคุณสามารถสะสมดาวในโปรแกรม Starbucks® Rewards ได้</p>
                                        <p>หากคุณยังไม่มีบัญชีสมาชิก Starbucks® Rewards กรุณาคลิกที่ปุ่มด้านล่างขวา เพื่อสมัครลงทะเบียนสมาชิก Starbucks® Rewards และผูกบัญชีสมาชิก หลังจากนั้นคุณสามารถสะสมดาวในโปรแกรม Starbucks® Rewards ได้</p>
                                        <p>ในกรณีต้องการนำบัญชีสมาชิก Starbucks® Rewards ที่ผูกกับบัญชีสมาชิก Grab ไว้แล้ว ไปทำการผูกกับบัญชีสมาชิกอื่นของ Grab จะต้องทำการยกเลิกการผูกบัญชี Starbucks® Rewards เดิมก่อน จึงจะสามารถนำบัญชีสมาชิก Starbucks® Rewards ไปผูกกับบัญชีสมาชิกอื่นของ Grab ได้</p>
                                        <p>ในกรณีบัญชีสมาชิก Starbucks® Rewards หรือบัญชีสมาชิก Grab ถูกยกเลิกการเป็นสมาชิก ระบบจะทำการยกเลิกการผูกบัญชีสมาชิกนั้นทันที และท่านจะไม่สามารถสะสมดาวในโปรแกรม Starbucks® Rewards ผ่านการซื้อสินค้าสตาร์บัคส์ที่อยู่บนแอปพลิเคชัน Grab ในครั้งถัดไปได้</p>
                                        <p>ข้อกำหนดและเงื่อนไขนี้จัดทำขึ้นเป็นภาษาไทยและภาษาอังกฤษ ในกรณีที่มีข้อขัดแย้งระหว่างข้อกำหนดและเงื่อนไขนี้ฉบับภาษาอังกฤษ และฉบับภาษาไทย ให้ยึดตามฉบับภาษาอังกฤษ</p>
                                        <p>เงื่อนไขข้อกำหนดอื่น ๆ ระหว่างคุณกับสตาร์บัคส์ที่เกี่ยวข้องกับ 1) ข้อกำหนดการใช้ Starbucks® Rewards 2) ข้อกำหนดในการใช้และสัญญาบัญชี Starbucks Card และ 3) นโยบายคุ้มครองข้อมูลส่วนบุคคล ให้อยู่ภายใต้บังคับข้อกำหนดเงื่อนไขที่ระบุบนเว็บไซต์ของสตาร์บัคส์ประเทศไทย ดังนี้<br />
                                            1) <a href="https://rewards.starbucks.co.th/thtermsofuse">https://rewards.starbucks.co.th/thtermsofuse</a><br />
                                            2) <a href="https://rewards.starbucks.co.th/thterms">https://rewards.starbucks.co.th/thterms</a><br />
                                            3) <a href="https://www.starbucks.co.th/online-policies/privacy-statement">https://www.starbucks.co.th/online-policies/privacy-statement</a></p>
                                        <p>Terms and conditions for linking Grab account to Starbucks® Rewards Program</p>
                                        <p>One (1) Grab account can only be linked to One (1) Starbucks® Rewards account at a time.</p>
                                        <p>When you have linked your Grab account with Starbucks® Rewards program, you will earn 1 Star on every 50 Baht spent on Starbucks products from Starbucks shop created by Coffee Concept Retail Co., Ltd. on Grab Application.</p>
                                        <p>The Stars will be calculated from the total amount shown on the original receipt issue by Coffee Concept Retail Co., Ltd. Only exclude delivery fee.</p>
                                        <p>Any promotional activities that take place at Starbucks stores shall not apply to all purchases of Starbucks products from Starbucks shop created by Coffee Concept Retail Co., Ltd. on Grab Application unless otherwise indicated specifically by Starbucks. Such purchases shall not be qualified to earn same number of Stars or Bonus Stars as spending in Starbucks stores.<br />
                                            <br />
                                            If you are a member of Starbucks® Rewards program, please click on the button on the bottom left to log in your “Starbucks® Rewards” account with your username (email) and password and link your Grab account with Starbucks® Rewards program. Afterwards, you will earn Star from Starbucks® Rewards program on your Starbucks order via Grab Application.</p>
                                        <p>If you are not a member of Starbucks® Rewards program, please click on the button on the bottom right to register for your Starbucks® Rewards account and link your Grab account with Starbucks® Rewards program. Afterwards, you will earn Star from Starbucks® Rewards program on your Starbucks order via Grab Application.</p>
                                        <p>You can reapply to another Grab account with the existing Starbucks® Rewards account by unlinking your current Grab account with your Starbucks® Rewards account.</p>
                                        <p>In the event that your Starbucks® Rewards account or Grab account is terminated, the system will immediately delink the two accounts and you will not be entitled to earn Starbucks® Rewards Stars earned through your next Starbucks purchase on the Grab Application.</p>
                                        <p>These terms and conditions were made in Thai and English. In case of any conflict between the provisions of the English version of these Terms and Conditions and and Thai version, the English version will prevail.</p>
                                        <p>Other terms and condition in connection with 1) Starbucks® Rewards 2) Starbucks Card Account Terms of Use and Agreement; and 3) Starbucks Privacy Notice shall be governed under the standard terms and conditions set forth on Starbucks Thailand website with the following URL:<br />
                                            1) <a href="https://rewards.starbucks.co.th/termsofuse">https://rewards.starbucks.co.th/termsofuse</a><br />
                                            2) <a href="https://rewards.starbucks.co.th/terms">https://rewards.starbucks.co.th/terms</a><br />
                                            3) <a href="https://www.starbucks.co.th/online-policies/privacy-statement">https://www.starbucks.co.th/online-policies/privacy-statement</a></p>
                                        <div className="form-check mb-4">
                                            <label className="form-check-label">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={termsChecked}
                                                    onChange={this.handleTermsChange}
                                                />{" "}
                                                รับทราบข้อตกลงและเงื่อนไข / I have read and agreed to the Terms &amp; Conditions.
                                            </label>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">                                                
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100 mb-3"
                                                    onClick={this.handleSubmitYes}
                                                    disabled={!termsChecked}
                                                >
                                                    เป็นสมาชิก / Yes
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    onClick={this.handleSubmitNo}
                                                    disabled={!termsChecked}
                                                >
                                                    ไม่เป็นสมาชิก / No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div style={{ marginTop: 24 }}>*/}
                        {/*    <small>*/}
                        {/*        Debug: grabUserId = {grabUserId || "(empty)"} <br/>*/}
                        {/*        merchantId = {merchantId || "(empty)"}*/}
                        {/*    </small>*/}
                        {/*</div>*/}
                    </section>
                </main>                

                <ZPartner01GrabFooter />
            </>

        );
    }
}
